<template>
  <!-- Navbar Start -->
  <nav
    class="navbar navbar-expand-lg bg-white navbar-light fixed-top shadow py-lg-0 px-4 px-lg-5 wow fadeIn"
    data-wow-delay="0.1s"
  >
    <a href="/" class="navbar-brand d-block d-lg-none">
      <h1 class="text-primary">Dylex Photography</h1>
    </a>
    <button
      type="button"
      class="navbar-toggler"
      data-bs-toggle="collapse"
      data-bs-target="#navbarCollapse"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div
      class="collapse navbar-collapse justify-content-between py-4 py-lg-0"
      id="navbarCollapse"
    >
      <div class="navbar-nav ms-auto py-0">
        <a href="/" class="nav-item nav-link active">Home</a>
        <a href="/about" class="nav-item nav-link">About</a>
        <a href="/services" class="nav-item nav-link">Services</a>
      </div>
      <a
        href="/"
        class="navbar-brand bg-primary py-2 px-4 mx-3 d-none d-lg-block"
      >
        <h1 class="text-white">Dylex Photography</h1>
      </a>
      <div class="navbar-nav me-auto py-0">
        <a href="/projects" class="nav-item nav-link">Projects</a>
        <a href="/contact" class="nav-item nav-link">Contact</a>
      </div>
    </div>
  </nav>
  <!-- Navbar End -->

  <!-- Header Start -->
  <div class="container-fluid hero-header bg-light py-5 mb-5">
    <div class="container py-5">
      <div class="row g-5 align-items-center">
        <div class="col-lg-6">
          <p class="text-primary text-uppercase mb-2 animated slideInDown">
            Welcome To Dylex Photography
          </p>
          <h1 class="display-4 mb-3 animated slideInDown">
            Wedding And Portrait Studio Based in Kigali Rwanda
          </h1>
          <p class="animated slideInDown">
            Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit. Aliqu
            diam amet diam et eos. Clita erat ipsum et lorem et sit, sed stet
            lorem sit clita duo justo magna dolore erat amet
          </p>
          <div class="d-flex align-items-center pt-4 animated slideInDown">
            <a href="" class="btn btn-primary py-3 px-4 me-5">Explore More</a>
            <button
              type="button"
              class="btn-play"
              data-bs-toggle="modal"
              data-src="https://www.youtube.com/embed/3fD_5dilk3s"
              data-bs-target="#videoModal"
            >
              <span></span>
            </button>
            <h5 class="ms-4 mb-0 d-none d-sm-block">Play Video</h5>
          </div>
        </div>
        <div class="col-lg-6 animated fadeIn">
          <div class="row g-3">
            <div class="col-6 text-end">
              <img
                class="img-fluid bg-white p-3 w-100 mb-3"
                src="img/hero-1.jpg"
                alt=""
              />
              <img
                class="img-fluid bg-white p-3 w-50"
                src="img/hero-3.jpg"
                alt=""
              />
            </div>
            <div class="col-6">
              <img
                class="img-fluid bg-white p-3 w-50 mb-3"
                src="img/hero-4.jpg"
                alt=""
              />
              <img
                class="img-fluid bg-white p-3 w-100"
                src="img/hero-2.jpg"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Header End -->

  <!-- Video Modal Start -->
  <div
    class="modal modal-video fade"
    id="videoModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content rounded-0">
        <div class="modal-header">
          <h3 class="modal-title" id="exampleModalLabel">Youtube Video</h3>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <!-- 16:9 aspect ratio -->
          <div class="ratio ratio-16x9">
            <iframe
              class="embed-responsive-item"
              src=""
              id="video"
              allowfullscreen
              allowscriptaccess="always"
              allow="autoplay"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Video Modal End -->

  <!-- About Start -->
  <div class="container-xxl py-5">
    <div class="container">
      <div class="row g-5">
        <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
          <div class="row g-3 img-twice position-relative h-100">
            <div class="col-6">
              <img
                class="img-fluid bg-light p-3"
                src="img/about-1.jpg"
                alt=""
              />
            </div>
            <div class="col-6 align-self-end">
              <img
                class="img-fluid bg-light p-3"
                src="img/about-2.jpg"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
          <div class="h-100">
            <p class="text-primary text-uppercase mb-2">About Us</p>
            <h1 class="display-6 mb-4">
              We Are Creative And Professional Photographer
            </h1>
            <p>
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit. Aliqu
              diam amet diam et eos. Clita erat ipsum et lorem et sit, sed stet
              lorem sit clita duo justo magna dolore erat amet
            </p>
            <p>
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit. Aliqu
              diam amet diam et eos. Clita erat ipsum et lorem et sit, sed stet
              lorem sit clita duo justo magna dolore erat amet
            </p>
            <div class="row g-2 mb-4">
              <div class="col-sm-6">
                <i class="fa fa-check text-primary me-3"></i>Quality Products
              </div>
              <div class="col-sm-6">
                <i class="fa fa-check text-primary me-3"></i>Custom Products
              </div>
              <div class="col-sm-6">
                <i class="fa fa-check text-primary me-3"></i>Online Order
              </div>
              <div class="col-sm-6">
                <i class="fa fa-check text-primary me-3"></i>Home Delivery
              </div>
            </div>
            <a class="btn btn-primary py-3 px-5" href="">Read More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- About End -->

  <!-- Service Start -->
  <div class="container-xxl bg-light py-5 my-5">
    <div class="container py-5">
      <div
        class="text-center mx-auto mb-5 wow fadeInUp"
        data-wow-delay="0.1s"
        style="max-width: 500px"
      >
        <p class="text-primary text-uppercase mb-2">Our Services</p>
        <h1 class="display-6 mb-4">We Provide Best Professional Services</h1>
      </div>
      <div class="row g-3">
        <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
          <div class="service-item d-flex flex-column bg-white p-3 pb-0">
            <div class="position-relative">
              <img class="img-fluid" src="img/service-1.jpg" alt="" />
              <div class="service-overlay">
                <a
                  class="btn btn-lg-square btn-outline-light rounded-circle"
                  href=""
                  ><i class="fa fa-link text-primary"></i
                ></a>
              </div>
            </div>
            <div class="text-center p-4">
              <h4>Weddings</h4>
            </div>
          </div>
        </div>
        <div
          class="col-lg-3 col-md-6 pt-lg-5 wow fadeInUp"
          data-wow-delay="0.3s"
        >
          <div class="service-item d-flex flex-column bg-white p-3 pb-0">
            <div class="position-relative">
              <img class="img-fluid" src="img/service-2.jpg" alt="" />
              <div class="service-overlay">
                <a
                  class="btn btn-lg-square btn-outline-light rounded-circle"
                  href=""
                  ><i class="fa fa-link text-primary"></i
                ></a>
              </div>
            </div>
            <div class="text-center p-4">
              <h4>Portraits</h4>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
          <div class="service-item d-flex flex-column bg-white p-3 pb-0">
            <div class="position-relative">
              <img class="img-fluid" src="img/service-3.jpg" alt="" />
              <div class="service-overlay">
                <a
                  class="btn btn-lg-square btn-outline-light rounded-circle"
                  href=""
                  ><i class="fa fa-link text-primary"></i
                ></a>
              </div>
            </div>
            <div class="text-center p-4">
              <h4>Fashion</h4>
            </div>
          </div>
        </div>
        <div
          class="col-lg-3 col-md-6 pt-lg-5 wow fadeInUp"
          data-wow-delay="0.7s"
        >
          <div class="service-item d-flex flex-column bg-white p-3 pb-0">
            <div class="position-relative">
              <img class="img-fluid" src="img/service-4.jpg" alt="" />
              <div class="service-overlay">
                <a
                  class="btn btn-lg-square btn-outline-light rounded-circle"
                  href=""
                  ><i class="fa fa-link text-primary"></i
                ></a>
              </div>
            </div>
            <div class="text-center p-4">
              <h4>Editorial</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Service End -->

  <!-- Project Start -->
  <div class="container-xxl py-5">
    <div class="container">
      <div
        class="text-center mx-auto mb-5 wow fadeInUp"
        data-wow-delay="0.1s"
        style="max-width: 500px"
      >
        <p class="text-primary text-uppercase mb-2">Our Works</p>
        <h1 class="display-6 mb-0">
          Discover Our Unique And Creative Photoshoot
        </h1>
      </div>
      <div class="row g-3">
        <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
          <div class="row g-3">
            <div class="col-12">
              <div class="project-item">
                <img class="img-fluid" src="img/project-5.jpg" alt="" />
                <a
                  class="project-title h5 mb-0"
                  href="img/project-5.jpg"
                  data-lightbox="project"
                >
                  Memory
                </a>
              </div>
            </div>
            <div class="col-12">
              <div class="project-item">
                <img class="img-fluid" src="img/project-1.jpg" alt="" />
                <a
                  class="project-title h5 mb-0"
                  href="img/project-1.jpg"
                  data-lightbox="project"
                >
                  Wedding
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
          <div class="row g-3">
            <div class="col-12">
              <div class="project-item">
                <img class="img-fluid" src="img/project-2.jpg" alt="" />
                <a
                  class="project-title h5 mb-0"
                  href="img/project-2.jpg"
                  data-lightbox="project"
                >
                  Portrait
                </a>
              </div>
            </div>
            <div class="col-12">
              <div class="project-item">
                <img class="img-fluid" src="img/project-6.jpg" alt="" />
                <a
                  class="project-title h5 mb-0"
                  href="img/project-6.jpg"
                  data-lightbox="project"
                >
                  Travel
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
          <div class="row g-3">
            <div class="col-12">
              <div class="project-item">
                <img class="img-fluid" src="img/project-7.jpg" alt="" />
                <a
                  class="project-title h5 mb-0"
                  href="img/project-7.jpg"
                  data-lightbox="project"
                >
                  Wedding
                </a>
              </div>
            </div>
            <div class="col-12">
              <div class="project-item">
                <img class="img-fluid" src="img/project-3.jpg" alt="" />
                <a
                  class="project-title h5 mb-0"
                  href="img/project-3.jpg"
                  data-lightbox="project"
                >
                  Memory
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
          <div class="row g-3">
            <div class="col-12">
              <div class="project-item">
                <img class="img-fluid" src="img/project-4.jpg" alt="" />
                <a
                  class="project-title h5 mb-0"
                  href="img/project-4.jpg"
                  data-lightbox="project"
                >
                  Fashion
                </a>
              </div>
            </div>
            <div class="col-12">
              <div class="project-item">
                <img class="img-fluid" src="img/project-8.jpg" alt="" />
                <a
                  class="project-title h5 mb-0"
                  href="img/project-8.jpg"
                  data-lightbox="project"
                >
                  Portrait
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Project End -->

  <!-- Team Start -->
  <div class="container-xxl px-0 py-5">
    <div
      class="text-center mx-auto mb-5 wow fadeInUp"
      data-wow-delay="0.1s"
      style="max-width: 500px"
    >
      <p class="text-primary text-uppercase mb-2">Our Team</p>
      <h1 class="display-6 mb-0">Creative Photograher And Videographer</h1>
    </div>
    <div class="row g-0">
      <div class="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
        <div class="row g-0 flex-sm-row">
          <div class="col-sm-6">
            <div class="team-img position-relative">
              <img class="img-fluid" src="img/team-1.jpg" alt="" />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="h-100 p-5 d-flex flex-column justify-content-between">
              <div class="mb-3">
                <h4>Lucifer Jhones</h4>
                <span>Photographer</span>
              </div>
              <p>
                Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit,
                sed stet lorem sit clita duo
              </p>
              <div class="d-flex">
                <a
                  class="btn btn-square btn-outline-primary rounded-circle me-2"
                  href=""
                  ><i class="fab fa-facebook-f"></i
                ></a>
                <a
                  class="btn btn-square btn-outline-primary rounded-circle me-2"
                  href=""
                  ><i class="fab fa-twitter"></i
                ></a>
                <a
                  class="btn btn-square btn-outline-primary rounded-circle me-2"
                  href=""
                  ><i class="fab fa-instagram"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 wow fadeIn" data-wow-delay="0.3s">
        <div class="row g-0 flex-sm-row-reverse flex-lg-row">
          <div class="col-sm-6">
            <div class="team-img position-relative">
              <img class="img-fluid" src="img/team-2.jpg" alt="" />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="h-100 p-5 d-flex flex-column justify-content-between">
              <div class="mb-3">
                <h4>Jesse Joslin</h4>
                <span>Videographer</span>
              </div>
              <p>
                Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit,
                sed stet lorem sit clita duo
              </p>
              <div class="d-flex">
                <a
                  class="btn btn-square btn-outline-primary rounded-circle me-2"
                  href=""
                  ><i class="fab fa-facebook-f"></i
                ></a>
                <a
                  class="btn btn-square btn-outline-primary rounded-circle me-2"
                  href=""
                  ><i class="fab fa-twitter"></i
                ></a>
                <a
                  class="btn btn-square btn-outline-primary rounded-circle me-2"
                  href=""
                  ><i class="fab fa-instagram"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
        <div class="row g-0 flex-lg-row-reverse">
          <div class="col-sm-6">
            <div class="team-img position-relative">
              <img class="img-fluid" src="img/team-3.jpg" alt="" />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="h-100 p-5 d-flex flex-column justify-content-between">
              <div class="mb-3">
                <h4>Richard Archer</h4>
                <span>Retoucher</span>
              </div>
              <p>
                Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit,
                sed stet lorem sit clita duo
              </p>
              <div class="d-flex">
                <a
                  class="btn btn-square btn-outline-primary rounded-circle me-2"
                  href=""
                  ><i class="fab fa-facebook-f"></i
                ></a>
                <a
                  class="btn btn-square btn-outline-primary rounded-circle me-2"
                  href=""
                  ><i class="fab fa-twitter"></i
                ></a>
                <a
                  class="btn btn-square btn-outline-primary rounded-circle me-2"
                  href=""
                  ><i class="fab fa-instagram"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 wow fadeIn" data-wow-delay="0.3s">
        <div class="row g-0 flex-sm-row-reverse">
          <div class="col-sm-6">
            <div class="team-img position-relative">
              <img class="img-fluid" src="img/team-4.jpg" alt="" />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="h-100 p-5 d-flex flex-column justify-content-between">
              <div class="mb-3">
                <h4>April Ryan</h4>
                <span>Editor</span>
              </div>
              <p>
                Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit,
                sed stet lorem sit clita duo
              </p>
              <div class="d-flex">
                <a
                  class="btn btn-square btn-outline-primary rounded-circle me-2"
                  href=""
                  ><i class="fab fa-facebook-f"></i
                ></a>
                <a
                  class="btn btn-square btn-outline-primary rounded-circle me-2"
                  href=""
                  ><i class="fab fa-twitter"></i
                ></a>
                <a
                  class="btn btn-square btn-outline-primary rounded-circle me-2"
                  href=""
                  ><i class="fab fa-instagram"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Team End -->

  <!-- Footer Start -->
  <div
    class="container-fluid footer position-relative bg-dark text-white-50 mt-5 py-5 px-4 px-lg-5 wow fadeIn"
    data-wow-delay="0.1s"
  >
    <div class="row g-5 py-5">
      <div class="col-lg-6 pe-lg-5">
        <a href="/" class="navbar-brand">
          <h1 class="display-5 text-primary">Dylex Photography</h1>
        </a>
        <p>
          Aliquyam sed elitr elitr erat sed diam ipsum eirmod eos lorem nonumy.
          Tempor sea ipsum diam sed clita dolore eos dolores magna erat dolore
          sed stet justo et dolor.
        </p>
        <p>
          <i class="fa fa-map-marker-alt me-2"></i>123 Street, Kigali, Rwanda
        </p>
        <p><i class="fa fa-phone-alt me-2"></i>0789326245</p>
        <p><i class="fa fa-envelope me-2"></i>info@tambagroup.xyz</p>
        <div class="d-flex justify-content-start mt-4">
          <a
            class="btn btn-square btn-outline-primary rounded-circle me-2"
            href="#"
            ><i class="fab fa-twitter"></i
          ></a>
          <a
            class="btn btn-square btn-outline-primary rounded-circle me-2"
            href="#"
            ><i class="fab fa-facebook-f"></i
          ></a>
          <a
            class="btn btn-square btn-outline-primary rounded-circle me-2"
            href="#"
            ><i class="fab fa-linkedin-in"></i
          ></a>
          <a
            class="btn btn-square btn-outline-primary rounded-circle me-2"
            href="#"
            ><i class="fab fa-instagram"></i
          ></a>
        </div>
      </div>
      <div class="col-lg-6 ps-lg-5">
        <div class="row g-5">
          <div class="col-sm-6">
            <h4 class="text-light mb-4">Quick Links</h4>
            <a class="btn btn-link" href="">About Us</a>
            <a class="btn btn-link" href="">Contact Us</a>
            <a class="btn btn-link" href="">Our Services</a>
            <a class="btn btn-link" href="">Terms & Condition</a>
            <a class="btn btn-link" href="">Support</a>
          </div>
          <div class="col-sm-6">
            <h4 class="text-light mb-4">Popular Links</h4>
            <a class="btn btn-link" href="">About Us</a>
            <a class="btn btn-link" href="">Contact Us</a>
            <a class="btn btn-link" href="">Our Services</a>
            <a class="btn btn-link" href="">Terms & Condition</a>
            <a class="btn btn-link" href="">Support</a>
          </div>
          <div class="col-sm-12">
            <h4 class="text-light mb-4">Newsletter</h4>
            <div class="w-100">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control border-0 bg-secondary"
                  style="padding: 20px 30px"
                  placeholder="Your Email Address"
                /><button class="btn btn-primary px-4">Sign Up</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Footer End -->

  <!-- Copyright Start -->
  <div
    class="container-fluid bg-dark text-white border-top border-secondary px-0"
  >
    <div class="d-flex flex-column flex-md-row justify-content-between">
      <div class="py-4 px-5 text-center text-md-start">
        <p class="mb-0">
          &copy; <a class="text-primary" href="#">Dylex Photography</a>. All Rights
          Reserved.
        </p>
      </div>
      <div
        class="py-4 px-5 bg-secondary footer-shape position-relative text-center text-md-end"
      >
        <p class="mb-0">
          Designed by
          <a class="text-primary fw-bold" href="https://tambagroup.xyz"
            >Tamba Group</a
          >
        </p>
      </div>
    </div>
  </div>
  <!-- Copyright End -->

  <!-- Back to Top -->
  <a
    href="#"
    class="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top"
    ><i class="bi bi-arrow-up"></i
  ></a>
</template>
